// @ts-nocheck
import api from "../../../../../api/axios"

export default class Bank {
	constructor(bank) {
		Object.assign(this, bank)
	}

	static async getAll() {
		const response = await api.get("bank")
		const banks = new Map(response?.data?.data?.map((bank) => [bank?.routingNumber, new Bank(bank)]))

		return banks
	}

	get displayName() {
		return `${this?.routingNumber} - ${this?.bankName}`
	}

	get shortName() {
		return this?.bankName.substring(0, 10)
	}
}
